<template>
    <div :class="[$style['mds-button-container'], classObject]" :data-mds-version="version">
        <slot></slot>
    </div>
</template>

<script>
    import MdsButtonContainerProps from './button-container_props.js';

    export default {
        name: 'MdsButtonContainer',
        props: MdsButtonContainerProps,
        computed: {
            classObject() {
                const obj = {};
                obj[this.$style['mds-button-container--right-aligned']] = this.rightAligned;

                return obj;
            },
        },
    };
</script>

<style lang="scss" module>
    @import './button-container.scss';
</style>
